import { RepresentativeHomeContainer } from './components/RepresentativeHomeContainer';

export const RepresentativeHomePage = RepresentativeHomeContainer;
